import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { cached } from '@glimmer/tracking';
import type { PreferredRateOnboardingOption } from 'lumen/components/hotel/wizards/preferred-rate-onboarding/preferred-rate-onboarding-options';
import type HotelWizardsPreferredRateOnboardingRoute from 'lumen/routes/hotel/wizards/preferred-rate-onboarding';
import { ROOMTYPE_TRANSLATION_KEYS } from 'lumen/utils/constants/general-constants';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelWizardsPreferredRateOnboardingRoomTypeController extends Controller {
  declare model: ModelFrom<HotelWizardsPreferredRateOnboardingRoute>;

  @service declare intl: Services['intl'];
  @service declare router: Services['router'];
  @service('wizards/preferred-rate-onboarding')
  declare wizardsPreferredRateOnboarding: Services['wizards/preferred-rate-onboarding'];

  @cached
  get roomTypeOptions(): PreferredRateOnboardingOption[] {
    if (
      !this.model.requestPricingAssistantRatePreferencesOptionsTaskResult.value
    ) {
      return [];
    }

    return this.model.requestPricingAssistantRatePreferencesOptionsTaskResult.value.roomType.map(
      (roomType) => {
        const { id } = roomType;
        const translationKey = ROOMTYPE_TRANSLATION_KEYS[id];
        return {
          id,
          label: translationKey ? this.intl.t(translationKey) : roomType.name,
          isChecked:
            roomType.id ===
            this.wizardsPreferredRateOnboarding.selectedRoomTypeId,
        };
      },
    );
  }

  @action onBack(): void {
    this.router.transitionTo(
      'hotel.wizards.preferred-rate-onboarding.rate-type',
    );
  }

  @action onContinue(): void {
    this.router.transitionTo('hotel.wizards.preferred-rate-onboarding.persons');
  }

  @action onSkip(): void {
    this.router.transitionTo('hotel.pricing-manager');
  }

  @action
  updateSelectedRoomType(value: PreferredRateOnboardingOption): void {
    // @ts-expect-error: Incorrect type
    this.wizardsPreferredRateOnboarding.updateRoomType(value.id);
  }
}
